import { Link, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Chip, Divider, Grid, Stack, Typography } from '@mui/material';
import StyledDashboardLayout from '../style';
import { useGetRoleDetailQuery } from '../../Redux/Service/RoleApi';

const humanize = (text) =>
   text
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

export default function ViewRole() {
   const { id } = useParams();

   const { data: roleDetails, isLoading, isError } = useGetRoleDetailQuery(id);

   const role = roleDetails?.response?.data;

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header d-flex justify-content-between m-3">
               <h1>View Role</h1>
               <div className="btnWrap">
                  <Link to="/role-permissions" className="btn addBtn">
                     <ArrowBackIcon /> Back
                  </Link>
               </div>
            </div>

            <div className="card customCard p-3 m-3">
               {isLoading ? (
                  <div>Loading...</div>
               ) : isError || !role ? (
                  <div>Failed to load role details.</div>
               ) : (
                  <Box sx={{ p: 3 }}>
                     {/* Header */}
                     <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Typography variant="h5" fontWeight={700}>
                           {humanize(role.roleName)}
                        </Typography>
                        {/* <Typography variant="caption" color="text.secondary">
                           Created:{' '}
                           {new Date(role.createdAt).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                           })}
                        </Typography> */}
                     </Box>

                     <Divider sx={{ mb: 3 }} />

                     <Typography fontWeight={600} mb={2}>
                        Module Permissions
                     </Typography>

                     <Grid container spacing={2}>
                        {role.modules?.map((module) => (
                           <Grid item xs={12} sm={6} md={4} key={module.moduleId}>
                              <Box
                                 sx={{
                                    border: '1px solid #E5E7EB',
                                    borderRadius: 3,
                                    p: 2,
                                    height: '100%',
                                 }}
                              >
                                 <Typography fontWeight={600} fontSize={15} mb={1.5}>
                                    {humanize(module.name)}
                                 </Typography>

                                 <Box display="flex" flexWrap="wrap" gap={1}>
                                    {module.permission?.map((perm) => (
                                       <Chip
                                          key={perm.id}
                                          label={humanize(perm.name)}
                                          color="primary"
                                          variant="outlined"
                                          size="small"
                                       />
                                    ))}
                                 </Box>
                              </Box>
                           </Grid>
                        ))}
                     </Grid>
                  </Box>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   );
}
